import React from 'react';

const InstrumentOverviewRightMenu = () => {
  return <></>;
};

export default InstrumentOverviewRightMenu;
